exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.at-menu__item-link {\n\t\theight: 45px;\n}\n.el-checkbox__label {\n\t  display: inline-grid;\n\t  width:90%;\n\t  white-space: pre-line;\n\t  word-wrap: break-word;\n\t  line-height: 20px;\n}\n@media screen and (max-width: 768px) {\n#tip{\n\t\t\twidth: 100%;\n}\n}\n@media screen and (min-width: 768px) and (max-width: 1200px) {\n#tip{\n\t\t\twidth: 100%;\n}\n}\n@media screen and (min-width: 1200px) {\n#tip{\n\t\t\twidth: 100%;\n}\n}\n.el-menu-vertical-demo:not(.el-menu--collapse) {\n\t\twidth: 200px;\n\t\t/* min-height: 400px; */\n\t\theight: 100%;\n}\n", ""]);

// exports
